export enum DtoState {
    Unchanged,
    Added,
    Modified,
    Deleted,
}
